import React from "react";
import { Svg } from "assets";
import { ButtonMain } from "components";
import { useNavigate } from "react-router";

export const SeeYourEvent = () => {
  const navigate = useNavigate();

  const goToPage = () => {
    navigate(`/events`, { replace: true });
  };

  return (
    <div className="in-celebration-box">
      <div className="in-celebration-content">
        <div className="container">
          <div className="in-celebration-form-wrapper see-your-event-wrapper">
            <Svg.ClappingCelebrationSvg />
            <div className="see-your-event-title_desc">
              <p className="see-your-event-title">
                Success! Your event has been created.
              </p>
              <p className="see-your-event-desc">
                Your event is ready! You can now manage the details and make any
                updates. Thank you for organizing with us!
              </p>
            </div>

            <ButtonMain
              classNameWrapper="celebration-button"
              text={"View Event"}
              type="button"
              onClick={goToPage}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
